import _get from "lodash/get";

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { createReducer } from 'redux-act';
import { getYodleeTopTakeaways } from "../../actions/yodlee";
export default createReducer(_defineProperty({}, getYodleeTopTakeaways.success, function (state, payload) {
  return _get(payload, 'top_takeaways');
}), null);